export default __webpack_public_path__ + "static/media/offing-jacqui-germain.5357e1f4.webp";